var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-1 pb-5"},[(_vm.chartOptions)?_c('highcharts',{key:_vm.chartKey,ref:"gantt",attrs:{"constructor-type":'ganttChart',"options":_vm.chartOptions}}):_vm._e(),_c('work-item-details-dialog',{ref:"workItemDetailsDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }